import { render, staticRenderFns } from "./lecturerItem.vue?vue&type=template&id=2892153e&scoped=true&"
import script from "./lecturerItem.vue?vue&type=script&lang=js&"
export * from "./lecturerItem.vue?vue&type=script&lang=js&"
import style0 from "./lecturerItem.vue?vue&type=style&index=0&id=2892153e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2892153e",
  null
  
)

export default component.exports